import {
	ABOUT_US_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import humbleBundle from 'root/src/client/public/humble-bundle-logo.jpg'
import bossaStudios from 'root/src/client/public/bossa-studios-logo.jpg'
import curve from 'root/src/client/public/curve-games-logo.jpg'
import dotemu from 'root/src/client/public/dotemu-logo.jpg'
import elevenbit from 'root/src/client/public/elevenbit.png'
import { colorsNew } from 'root/src/client/web/commonStyles'
import aboutUs1 from 'root/src/client/public/backgroundBlobs/aboutUs1.svg'
import aboutUs2 from 'root/src/client/public/backgroundBlobs/aboutUs2.svg'
import { GET_TOP_ACTIVE_CREATORS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { aboutUsListType } from 'root/src/shared/constants/moduleTypes'

export const pageContent = {
	title: 'ABOUT US',
	subTitle: "We're a group of gamers, marketers, and developers who created Dare Drop to make game discovery fun, engaging, and productive for everyone.",
	cards: [
		{
			title: 'CREATORS',
			subTitle: 'We help creators engage with their viewers with dares & rewards.',
			borderColor: colorsNew.primary,
		},
		{
			title: 'PUBLISHERS',
			subTitle: 'We help developers & publishers engage creators & gamers to get their games discovered.',
			borderColor: colorsNew.light1,
			publishers: [
				{
					img: humbleBundle,
					displayName: 'Humble Bundle',
				},
				{
					img: bossaStudios,
					displayName: 'Bossa Studios',
				},
				{
					img: curve,
					displayName: 'Curve Games',
				},
				{
					img: dotemu,
					displayName: 'Dotemu',
				},
				{
					img: elevenbit,
					displayName: '11Bit',
				},
			],
		},
	],
}

export default {
	[ABOUT_US_MODULE_ID]: {
		moduleType: 'list',
		listType: aboutUsListType,
		endpointId: [GET_TOP_ACTIVE_CREATORS],
		backgroundData: [
			{
				position: 'right',
				image: aboutUs1,
				style: {
					transform: 'translate(45%, -19%)',
				},
			},
			{
				position: 'left',
				image: aboutUs2,
				style: {
					transform: 'translate(0%, 30%)',
					zIndex: 2,
				},
			},
		],
	},
}
